import React, { useState, useEffect } from 'react'
import axios from "axios"
import parse from 'html-react-parser'
import { useParams, Link, useNavigate } from "react-router-dom"
import { Add } from './Add'

const View = () => {
    const navigate = useNavigate()

    const { key, judul } = useParams()
    const [msg, setMsg] = useState("")
    const [pesan, setPesan] = useState(false)
    const [add, setAdd] = useState(false)
    const [list, setList] = useState([])
    const [potensialCode, setPotensialCode] = useState('')
    const [potensialName, setPotensialName] = useState('')
    const [title, setTitle] = useState('')
    const [profile, setProfile] = useState('')
    const [description, setDescription] = useState('')
    const [endDate, setEndDate] = useState('')
    const [url, setUrl] = useState('')
    const [token, setToken] = useState("")

    useEffect(() => {
        if (key) {
            getData(key)
            getList()
            updateToken()
        }
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [key])

    // Ambil data token session user
    const updateToken = async () => {
        try {
            const response = await axios.get('/api/pelaku-usaha/token')
            if (response && response.data) {
                setToken(response.data.authToken)
            } else {
                setToken('')
            }
        } catch (err) {
            setToken('')
        }
    }

    const getData = async (targetCode) => {
        try {
            const currentCode = targetCode || key
            if (!currentCode) return

            const response = await axios.post("/api/procurement/publish", {
                code: currentCode,
                jml: 1
            })

            if (response.data && response.data.length > 0) {
                const item = response.data[0]
                setProfile(item.profile)
                setTitle(item.title)
                setDescription(item.description)
                setUrl(item.filePath)
                setPotensialCode(item.potensialCode)
                setPotensialName(item.potensialName)
                setEndDate(item.end_date)
            } else {
                console.warn("Data kemitraan tidak ditemukan di DB.")
            }
        } catch (error) {
            console.error("Gagal load detail kemitraan:", error)
        }
    }

    const getList = async () => {
        try {
            const response = await axios.post("/api/procurement/publish", {
                jml: 6
            })
            setList(response.data)
        } catch (error) {
            console.error("Gagal load sidebar list:", error)
        }
    }

    const handleSelectPromosi = (val) => {
        const slugTitle = val.title.replaceAll(' ', '-').replaceAll('/', '_').toLowerCase()
        navigate(`/kebutuhan-pengadaan/${val.code}/${slugTitle}`)
    }

    const getPesan = () => {
        setPesan((prevState) => !prevState)
        if (pesan) {
            setTimeout(() => setMsg(""), 300)
        }
    }

    const display = {
        display: `${pesan ? "block" : "none"}`,
    }

    const openAdd = () => {

        if (!token) {
            setMsg("Anda harus login terlebih dahulu untuk mengirim permohonan!")
            setPesan(true)

            setTimeout(() => {
                setPesan(false)
                navigate("/login")
            }, 2000)

            return;
        }

        getAdd()
    }

    const closeAdd = () => {
        getAdd()
    }

    const getAdd = () => {
        setAdd((prevState) => !prevState)
    }

    const displayAdd = {
        display: `${add ? "block" : "none"}`
    }

    const tglBerakhir = new Date(endDate).toLocaleDateString('id-ID', {
        day: 'numeric', month: 'long', year: 'numeric'
    })

    return (<>
        <header className="ms-hero-page-override-home no-mt pb-4">
            <div className="container">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb breadcrumb-slash">
                        <li className="breadcrumb-item">
                            <Link to={'/'} className="btn btn-raised btn-primary br-2 no-m">BERANDA</Link>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">PELUANG KEMITRAAN STRATEGIS</li>
                        <li className="breadcrumb-item active">
                            {judul ? judul.replaceAll('-', ' ').replaceAll('_', '/').toUpperCase() : ''}
                        </li>
                    </ol>
                </nav>
                <div className="row mt-4">
                    <div className="col-md-3">
                        <div className="card card-primary">
                            <div className="card-header">
                                <h3 className='panel-judul'>KEMITRAAN LAINNYA</h3>
                            </div>
                            <div className="card-body">
                                <div className="ms-media-list">
                                    {list && list.length > 0 ? list
                                        // 1. Saring di FE biar iklan utama gak nongol di list samping bray
                                        .filter(val => val.code !== key)
                                        // 2. Tampilkan datanya bray
                                        .map((val, index) => (
                                            <div
                                                onClick={() => handleSelectPromosi(val)}
                                                key={index}
                                                className="media mb-2 d-block border-bottom pb-2 text-decoration-none"
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <div className="media-body">
                                                    <span className="media-heading color-dark font-bold d-block text-truncate" title={val.title}>
                                                        {val.title}
                                                    </span>
                                                    <div className="media-footer text-small color-dark">
                                                        <span className="mr-1 text-truncate d-block">
                                                            {val.description ? val.description.replace(/<[^>]*>/g, '').substring(0, 45) + '...' : ''}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        )) : <p className="text-center text-muted p-2">Tidak ada kemitraan lain</p>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-7"> {/* Gua naikin jadi 9 biar layouting kanan lebih lapang nan gagah bray */}
                        <h1 className='color-dark font-bold lh-125'>{title}</h1>
                        <h3 className='text-muted mb-3'>
                            {profile}
                        </h3>
                        
                        {url && url !== '-' && (
                            <iframe width="100%" height="500px" className="mb-3 border-0 shadow-sm" src={url} title="Preview File" />
                        )}

                        <div className="m-0">
                            <span className="badge badge-danger  border-danger border-left-3">
                                <i className="zmdi zmdi-time mr-1"></i>
                                Berlaku s/d: <strong>{tglBerakhir}</strong>
                            </span>
                        </div>
                        <div className="content-detail color-dark lead mb-4">
                            {description ? parse(description) : ''}
                        </div>
                        <button onClick={openAdd} className="btn btn-raised btn-warning br-2 font-bold">Kirim Permohonan <i className="ml-1 no-mr zmdi zmdi-long-arrow-right"></i></button>
                    </div>
                </div>
            </div>
        </header>

        {/* Modal Form Kirim Permohonan */}
        {add && (
            <div className="modal-open">
                <div style={displayAdd} className="modal modal-primary show" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog review">
                        <div className="modal-content modal-md">
                            <div className="modal-header header-modal-primary p-2 d-flex justify-content-between align-items-center">
                                <h4 className="modal-title font-bold" id="myModalLabel">Pengajuan Penawaran</h4>
                                <button type="button" className="close text-white" onClick={closeAdd}>&times;</button>
                            </div>
                            <div className="modal-body">
                                <Add requestCode={key} potensialCode={potensialCode} potensialName={potensialName} closeAdd={closeAdd} getPesan={getPesan} setMsg={setMsg} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade in" onClick={closeAdd}></div>
            </div>
        )}

        {/* Modal Notifikasi Pesan Sukses/Gagal */}
        {pesan && (
            <div className="modal-open">
                <div style={display} className="modal modal-primary show" id="myData" tabIndex="-1" role="dialog" aria-hidden="true" onClick={getPesan}>
                    <div className="modal-dialog center" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content modal-sm">
                            <div className="modal-header header-modal-primary p-2">
                                <h4 className="modal-title text-center no-p font-bold" id="myModalLabel">
                                    PESAN
                                </h4>
                            </div>
                            <div className="modal-body text-center p-4">
                                <h4 className="font-bold color-dark">{msg ? msg.toUpperCase() : ''}</h4>
                                <button onClick={getPesan} className="btn btn-raised btn-primary btn-sm mt-3">OK</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade in"></div>
            </div>
        )}
    </>)
}

export default View